export const dateFilters = [
  {
    option: "Today",
    startDate: (() => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return today.toISOString();
    })(),
    endDate: (() => {
      const today = new Date();
      today.setHours(23, 59, 59, 999);
      return today.toISOString();
    })(),
  },
  {
    option: "Yesterday",
    startDate: (() => {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      return yesterday.toISOString();
    })(),
    endDate: (() => {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday.setHours(23, 59, 59, 999);
      return yesterday.toISOString();
    })(),
  },
  {
    option: "Last 3 Days",
    startDate: (() => {
      const lastThreeDays = new Date();
      lastThreeDays.setDate(lastThreeDays.getDate() - 3);
      return lastThreeDays.toISOString().split("T")[0];
    })(),
    endDate: (() => {
      const today = new Date();
      today.setHours(23, 59, 59, 999);
      return today.toISOString();
    })(),
  },
  {
    option: "Last Week",
    startDate: (() => {
      const lastWeek = new Date();
      lastWeek.setDate(lastWeek.getDate() - 7);
      return lastWeek.toISOString().split("T")[0];
    })(),
    endDate: new Date().toISOString().split("T")[0],
  },
];


export function getEntity(data, entity) {
  const found = data.find((e) => e.name === entity);
  return found ? found : null;
}

export function getReasonEntity(data, entity) {
  const found = data.find((e) => e.reason === entity);
  return found ? found : null;
}
export function getWorkTimeEntity(data, entity) {
  const found = data.find((e) => e.duration === entity);
  return found ? found : null;
}
export function getEntityByProperty(property, data, entity) {
  const found = data.find((e) => e[property] === entity);
  return found ? found : null;
}

export function filterViewTypes(siteType, viewTypes) {
  let allowedNames;
  if (siteType === "متحرك") {
    allowedNames = ["كراسي الراحة"];
    return viewTypes.filter((view) => allowedNames.includes(view.name));
  }
  return viewTypes;
}

export function filterPaymentMethods(siteName, payments) {
  const filteredPayments = payments.filter((payment) => {
    return payment.Sites?.some((site) => site.name === siteName);
  });
  return filteredPayments;
}
